import { KinoSubscription } from '../models/kino-subscription.model';
import { PlanTypes } from '../models/plan.model';

export const getSubscriptionRenewalDate = (
  subscription: KinoSubscription | null
): Date | null => {
  if (!subscription || !subscription.isAutoRenewed) {
    return null;
  }
  return subscription.endDate;
};

export const getIsSubscriptionRenewable = (
  subscription: KinoSubscription | null
): boolean => {
  return (
    subscription?.plan?.name === PlanTypes.Month ||
    subscription?.plan?.name === PlanTypes.Year
  );
};

export const getIsSubscriptionAutoRenewCancelled = (
  subscription: KinoSubscription | null
): boolean => {
  const isRenewable: boolean = getIsSubscriptionRenewable(subscription);
  return isRenewable && !subscription.isAutoRenewed;
};

export const getIsFamilyOptionAutoRenewCancelledOnly = (
  subscription: KinoSubscription | null
) => {
  return (
    getIsSubscriptionRenewable(subscription) &&
    !getIsSubscriptionAutoRenewCancelled(subscription) &&
    !!subscription?.familyOption &&
    !subscription.familyOption.isAutoRenewed
  );
};
